module.exports = global.config = {
  api: {
    headers: {
      'Content-Type': 'application/json',
    },
  },
};
